import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    StormOSLinkClose,
    StormOSLinkOpen
} from '../../reducers/menus.js';
import {
    connectStormOs
} from '../../lib/get-Link-fn.js';
import USB from '../linkTab/USB.png';
import WIFI from '../linkTab/WIFI.png';

import styles from './stormOs-link.css';

class StormLink extends Component {
    constructor() {
        super()
        this.state = {
            ip: "",
            status: false,
            tipValue: "",
            page: 1
        }
        this.handleChange = this.handleChange.bind(this)
        this.handleLink = this.handleLink.bind(this)
        this.checkIp = this.checkIp.bind(this)
        this.handleSetPage = this.handleSetPage.bind(this)
        this.handleLineUSB = this.handleLineUSB.bind(this)
    }
    componentDidMount() {
        let ip = localStorage.getItem("Storm") || ''

        this.checkIp(ip)

        if (this.inputs) {
            this.inputs.focus()
        }
    }
    handleChange(e) {
        var value = e.target.value
        localStorage.setItem('Storm', value)
        this.checkIp(value)

    }
    handleSetPage(page) {
        this.setState({
            page: page
        })
    }
    checkIp(value) {
        // var reg = value.match(/^(((2[0-5]{2})|(1[0-9]{2})|([0-9]{2})|([0-9]))\.){3}((2[0-5]{2})|(1[0-9]{2})|([0-9]{2})|([0-9]))$/ig)
        var reg = value.match(/^(25[0-5]\.|2[0-4][0-9]\.|1[0-9][0-9]\.|[1]?[1-9]?[0-9]\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|1?[1-9]?[0-9])$/ig)
        if (reg) {
            this.setState({
                ip: value,
                status: true,
                tipValue: ""
            })
        } else {
            this.setState({
                ip: value,
                status: false,
                tipValue: "无效ip"
            })
        }
    }
    handleLink() {
        this.props.StormOSLinkClose()
        connectStormOs(this.state.ip)
    }
    handleLineUSB() {
        this.props.StormOSLinkClose()
        connectStormOs("172.24.234.10")
    }
    render() {
        const {
            StormOSLinkClose,
            ...components
        } = this.props
        return (
            <div className={styles.Alert}>
                {this.state.page == 1 ? <div className={styles.selectWifi}>

                    <div>
                        <img src={USB} alt="USB" onClick={this.handleLineUSB} />
                        <img src={WIFI} alt="WIFI" onClick={() => { this.handleSetPage(2) }} />
                    </div>
                    <div>
                        <span onClick={this.props.StormOSLinkClose}>X</span>
                    </div>

                </div> : <div className={styles.Containers}>
                    <div>
                        <input type="text"
                            placeholder="请输入ip地址"
                            value={this.state.ip}
                            ref={(e) => { this.inputs = e }}
                            onChange={this.handleChange}
                        />
                    </div>
                    <span className={styles.tips}>{this.state.tipValue}</span>
                    <div className={styles.listBtn}>
                        <button onClick={StormOSLinkClose}>取消</button>
                        <button onClick={this.handleLink}>连接</button>
                    </div>
                </div>}

            </div>
        )
    }
}

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = (dispatch) => ({
    StormOSLinkClose: () => {
        dispatch(StormOSLinkClose())
    },
    StormOSLinkOpen: () => {
        dispatch(StormOSLinkOpen())
    }
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StormLink)
